import { FC } from 'react';
import { TagTypeWithColor, tag_types } from './tag_type';

interface IProps {
	on_select_tag_type: (tag: TagTypeWithColor) => void;
	disabled?: boolean;
}

export const SelectTagType: FC<IProps> = ({ on_select_tag_type, disabled }) => {
	return (
		<>
			<h2 className='text-sm pb-1'>Selecione o Tipo de Conteúdo</h2>
			<ul className='flex flex-row mb-1'>
				{tag_types.map((tag_type) => {
					if (disabled && tag_type.value === 'video') {
						return null;
					}

					const blocked = disabled && tag_type.value !== 'ia';

					return (
						<li
							key={tag_type.value}
							title={
								blocked
									? 'Indisponível: o contrato já libera Fórum Assinaturas'
									: undefined
							}
							className={`
								my-1 mx-0.5 py-1 px-2 rounded text-white
								${tag_type.color}
								${blocked ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:bg-opacity-70'}
							`}
							onClick={() => {
								if (blocked) {
									return;
								}

								on_select_tag_type(tag_type);
							}}
						>
							{tag_type.title}
						</li>
					);
				})}
			</ul>
		</>
	);
};
